class ProductUpsell extends HTMLElement {
  constructor() {
    super();
    const productsDataScript = this.querySelector('[type="application/json"]')?.innerHTML;
    if (productsDataScript) {    
        this.productsData = JSON.parse(productsDataScript);
    }
  }

  connectedCallback() {
    this.setupEventListeners();
    this.slider = this.querySelector('.product-upsell__slider');
    this.initSlider();
  }

  setupEventListeners() {
    const button = this.querySelector('.button');
    if (button) {
      button.addEventListener('click', this.handleButtonClick.bind(this));
    }

    const productSelect = this.querySelector('.js-product-select');
    if (productSelect) {
        productSelect.addEventListener('change', this.handleProductChange.bind(this));
    }

    this.variantSelect = this.querySelector('.js-variant-select');
  }

  initSlider() {
    const swiper = new Swiper(this.slider, {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 1, 
      loop: true,
    });  

    console.log({swiper});
  }

  handleButtonClick(e) {
    e.preventDefault();
    const value = this.variantSelect.value;

    if (!value) {
      console.warn('No variant selected in upsell');
      return;
    }

    this.addItemToCart(value);
  }

  handleProductChange(e) {
    const id = e.target.value;
    this.renderVariantSelect(id);
  }

  renderVariantSelect(id) {
    const variants = this.productsData[id];

    this.variantSelect.innerHTML = variants.filter(x => x.available).map(y => `<option value="${y.id}">${y.option1}</option>`).join('');
  }

  async addItemToCart(variantId) {
    const button = this.querySelector('.button');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    const sectionsToRender = ['variant-added'];
    formData.append('sections', sectionsToRender.join(','));
    formData.append('sections_url', `${Shopify.routes.root}variants/${variantId}`);

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const responseJson = await response.json();

      if (response.ok) {
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        this.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent
            }
          })
        );

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else {
        this.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: responseJson.description || 'Could not add to cart.' }
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('Cart add error:', err);
      this.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: { error: 'Network error. Please try again.' }
        })
      );
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
  }
}

customElements.define('product-upsell', ProductUpsell);